// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".title-container[data-v-67ed6d78]{min-height:50px;width:100%;position:absolute;top:0;z-index:5;border-radius:10px 10px 0 0;background:linear-gradient(180deg,rgba(0,0,0,.32),rgba(0,0,0,.35) 30%,transparent)}.campaign-title[data-v-67ed6d78]{font-size:16px;font-family:Gothic A1,sans-serif;margin-top:16px;margin-left:16px;z-index:5;text-align:start;width:85%;color:#fff;font-weight:500}@media(max-width:320px){.campaign-title[data-v-67ed6d78]{font-size:14px;font-weight:400}}", ""]);
// Exports
module.exports = exports;
